import http from 'hub-http/clients/apiClient';
export const fetchHelpDesk = () => http.get(`messages/v2/helpdesk/settings`);